const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
const isLocalBrowser = typeof window !== "undefined" && ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname);
const isDesktopApp = typeof window !== "undefined" && window.location.protocol === "file:";
const productionApiBaseUrl = "https://amazon-ad-agent-saas-api.gzyangle2018.workers.dev";

export const API_BASE_URL = configuredBaseUrl?.replace(/\/$/, "") || (isLocalBrowser ? "http://localhost:8787" : isDesktopApp ? productionApiBaseUrl : "");

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

function apiUrl(path: string) {
  return API_BASE_URL ? `${API_BASE_URL}${path}` : path;
}

function apiHeaders() {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("ad-agent-token");
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

async function throwApiError(response: Response, method: string, path: string): Promise<never> {
  let message = `API ${method} ${path} failed: ${response.status}`;
  try {
    const payload = await response.json() as { error?: string; message?: string };
    message = payload.error || payload.message || message;
  } catch {
    // Keep the status-based fallback when the backend does not return JSON.
  }
  throw new ApiError(message, response.status);
}

export async function apiGet<T>(path: string): Promise<T> {
  const response = await fetch(apiUrl(path), { headers: apiHeaders() });
  if (!response.ok) return throwApiError(response, "GET", path);
  return response.json() as Promise<T>;
}

export async function apiPost<T>(path: string, body?: unknown): Promise<T> {
  const response = await fetch(apiUrl(path), {
    method: "POST",
    headers: apiHeaders(),
    body: body === undefined ? undefined : JSON.stringify(body)
  });
  if (!response.ok) return throwApiError(response, "POST", path);
  return response.json() as Promise<T>;
}
